import {
  Box3,
  Group,
  Mesh,
  MeshStandardMaterial,
  Object3D,
  Vector3,
} from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

export interface LoadedBoard {
  root: Group;
  named: Map<string, Object3D>;
  bounds: Box3;
}

export async function loadBoard(url: string): Promise<LoadedBoard> {
  const gltf = await new GLTFLoader().loadAsync(url);
  const root = gltf.scene;
  const named = new Map<string, Object3D>();

  root.traverse((object) => {
    if (object.name) named.set(object.name, object);
    if (object instanceof Mesh) {
      object.castShadow = false;
      object.receiveShadow = true;
      const materials = Array.isArray(object.material) ? object.material : [object.material];
      for (const material of materials) {
        if (material instanceof MeshStandardMaterial) {
          material.envMapIntensity = 0.65;
          material.needsUpdate = true;
        }
      }
    }
  });

  const bounds = new Box3().setFromObject(root);
  const center = bounds.getCenter(new Vector3());
  // KiCad export is already correctly scaled. Only remove tiny origin drift.
  root.position.sub(new Vector3(center.x, 0, center.z));
  bounds.setFromObject(root);
  return { root, named, bounds };
}
